




























import { Component, Mixins } from 'vue-property-decorator';
import { Actions } from '@/ts/store/Constants';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';

@Component
export default class ResetPin extends Mixins(InputFieldMethods) {
    constructor() {
        super();
    }

    public dismissDialog() {
        this.$router.push('login');
    }

    public resetPin() {
        this.$store.dispatch(Actions.RESET_PIN);
    }
}
